module.exports = __webpack_public_path__ + "static/media/nham24-icon.75935c7a.png";